import React from 'react'
// import { useNavigate } from "react-router-dom";
// import {
//   Button,
//   Typography,
//   Box,
//   Card,
//   CardContent,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { Worker, Viewer } from "@react-pdf-viewer/core";
import '@react-pdf-viewer/core/lib/styles/index.css'
import DocumentList from '../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../Config/Config'
import PolicyData from '../../Assets/JSON/Institutionalpolicy/Institutionalpolicy.json'

const InstitutionalPolicy = () => {
  // const docTitle = "Insitutional Policy";
  // const navigate = useNavigate();

  // const handleBackClick = () => navigate(-1);

  // const fullFileUrl = `${IMAGE_BASE_PATH_DBRALC}dbralc/policy,handbook,manual.pdf`;

  // const isPdf = fullFileUrl?.endsWith(".pdf");
  // const isImage = /\.(jpeg|jpg|png|gif|bmp)$/i.test(fullFileUrl);
  // const isOffice = /\.(doc|docx|xls|xlsx|ppt|pptx)$/i.test(fullFileUrl);

  return (
    <div>
      <DocumentList
        data={PolicyData}
        title="Institutional Policy"
        basePath={IMAGE_BASE_PATH_DBRALC}
        navigatePath="/institutionalpolicy"
      />
    </div>
  )
}

export default InstitutionalPolicy
